import React, { Component } from 'react';
import { withTranslation } from '../../lib/translate.js';
import { NormalText, SmallText, Spacer, StrongText, Subtitle } from '../common/index.js';
import moment from 'moment';
import './index.css';
import { checkmark, close } from 'ionicons/icons';
import { IonIcon } from '@ionic/react';

class OrderStatus extends Component {
	render() {
		const { __, events } = this.props;
		const formattedEvents = events.filter((item, index, arr) => {
			return index === 0 || item?.order_status !== arr[index - 1]?.order_status;
		});
		return (
			<>
				<StrongText className='block text-to-update'>{__('Order status')}</StrongText>
				<Spacer size={2} />
				<div className="order-status-details">
					{formattedEvents.map((event, index) => (
						<div key={`order-status_${index}`} className="order-status-details-line">
							<div>
								{event.order_status.toLowerCase().includes('fail') ? (
									<IonIcon className="order-status-failed" icon={close} color="white"></IonIcon>
								) : (
									<IonIcon className="order-status-success" icon={checkmark} color="white"></IonIcon>
								)}
							</div>
							<div className="box-content">
								<SmallText className="block">{moment(event.timestamp).format(`L [${__('at')}] h:mm a`)}</SmallText>
								<StrongText>{__(`${event.order_status.toLowerCase() == 'new' ? 'Created' : event.order_status.replaceAll("_", " ")}`)}</StrongText>
							</div>
						</div>
					))}
				</div>
			</>
		);
	}
}

export default withTranslation(OrderStatus);
